var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('loading',{attrs:{"is-loading":_vm.isLoading}}),_c('layout-default',[_c('error-boundary',[_c('keep-alive',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }